import React from 'react'
import { push } from 'redux-first-router'

export const usePuppeteerGoto = () => {
  React.useEffect(() => {
    // Exposes redux router on the global namespace so that puppeteer
    // can change routes without reloading the entire application
    ;(window as any).goto = (url: string) => push(new URL(url, window.location.href).pathname)

    return () => { delete (window as any).goto }
  }, [])
}
